import { ReactNode } from 'react'

import { Button } from '@/components/base/button'
import { Drawer } from '@/components/base/drawer'
import { Heading } from '@/components/base/heading'
import { FormContainer } from '@/components/form/form'
import { useI18n } from '@/i18n/i18n-react'

interface AdvancedFilterDrawerProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	onClearAll: () => void
	onApplyClick: () => void
	title?: string
	children: ReactNode
}

export function AdvancedFilterDrawer({
	open,
	onOpenChange,
	onClearAll,
	onApplyClick,
	title,
	children
}: AdvancedFilterDrawerProps) {
	const { L } = useI18n()

	return (
		<Drawer open={open} onOpenChange={onOpenChange}>
			<Drawer.Content>
				<Drawer.Header>
					<Drawer.Title asChild>
						<Heading>{title || L.General.AdvancedFilters()}</Heading>
					</Drawer.Title>
				</Drawer.Header>
				<form
					onSubmit={e => {
						e.preventDefault()
						onApplyClick()
					}}
				>
					<Drawer.Body className='flex-1 overflow-auto'>
						<FormContainer>{children}</FormContainer>
					</Drawer.Body>
					<Drawer.Footer>
						<div className='flex items-center justify-end gap-x-2'>
							<Button variant='secondary' size='small' onClick={onClearAll} type='button'>
								{L.General.ClearAll()}
							</Button>
							<Button variant='primary' size='small' type='submit'>
								{L.General.Apply()}
							</Button>
						</div>
					</Drawer.Footer>
				</form>
			</Drawer.Content>
		</Drawer>
	)
}
